// client/src/shared/ui/ErrorBoundary.tsx
// Composant Error Boundary React — affiche un bandeau rouge avec le nom du composant,
// le message d'erreur et le stack trace en cas de crash.

import { Component, type ReactNode } from 'react'

interface Props {
  name: string
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error(`[ErrorBoundary:${this.props.name}]`, error, info.componentStack)
  }

  render() {
    if (this.state.hasError && this.state.error) {
      const { name } = this.props
      const { error } = this.state
      return (
        <div
          style={{
            background: '#fef2f2',
            border: '1px solid #fca5a5',
            borderRadius: 6,
            padding: '12px 16px',
            margin: 8,
            fontFamily: 'monospace',
            fontSize: 12,
            color: '#991b1b',
          }}
        >
          <div style={{ fontWeight: 700, marginBottom: 6, fontSize: 13 }}>
            Erreur dans &lt;{name}&gt;
          </div>
          <div style={{ marginBottom: 8, color: '#b91c1c' }}>
            {error.message}
          </div>
          {error.stack && (
            <pre
              style={{
                margin: 0,
                padding: '8px',
                background: '#fee2e2',
                borderRadius: 4,
                overflowX: 'auto',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
                fontSize: 11,
                color: '#7f1d1d',
                maxHeight: 200,
                overflow: 'auto',
              }}
            >
              {error.stack}
            </pre>
          )}
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              marginTop: 10,
              padding: '4px 12px',
              background: '#ef4444',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: 12,
              fontFamily: 'monospace',
            }}
          >
            Réessayer
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
